import http from '../http'
import url from './index-url'
const { post, get } = http

export default {
  // 课程列表
  getCourseList(data) {
    return post(url.getCourseList, data)
  },
  // 小组列表
  getGroupList(data) {
    return post(url.getGroupList, data)
  },
  getTeacherList(data) {
    return get(url.getTeacherList, data)
  },
  getStudentList(data) {
    return post(url.getStudentList, data)
  },
  getGradeList(data) {
    return get(url.getGradeList, data)
  },
  createGroup(data) {
    return post(url.createGroup, data)
  },
  updateGroup(data) {
    return post(url.editGroup, data)
  },
  getParams() {
    return get(url.getParams)
  },
  getSelectedStudentList(data) {
    return post(url.getSelectedStudentList, data)
  },
  getCourseListByName(data) {
    return post(url.getCourseListByName, data)
  },
  checkStudentConflict(data) {
    return post(url.checkStudentConflict, data)
  },
  adminCourseMaterials({ classTypeId }) {
    return get(url.adminCourseMaterials(classTypeId))
  },
  findCourseware(data) {
    return get(url.findCourseware(data))
  }
}